//routes
import Navigator from '@/routes';
//styles
import '@styles/global.scss';
//constants
import {COLORED, TOP_RIGHT} from './utils/constants';
//components
import {ToastContainer, Slide} from 'react-toastify';
import {useEffect} from 'react';

const App = () => {
	useEffect(() => {
		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}
	}, []);

	return (
		<div className="app">
			<ToastContainer
				position={TOP_RIGHT}
				theme={COLORED}
				autoClose={2500}
				hideProgressBar
				newestOnTop={false}
				rtl={false}
				pauseOnFocusLoss={false}
				pauseOnHover={false}
				draggable={false}
				transition={Slide}
			/>
			<Navigator />
		</div>
	);
};

export default App;
